import { ModelSagres } from "../model-sagres"

export class Suspensao extends ModelSagres {
    NrProtocoloSuspensao: string
    NrAnoprotocoloSuspensao: string
    DtSuspensao: Date
    FlAtivo: boolean


    constructor(obj?: any) {
        super();
        if (obj) {
            if (obj.NrProtocoloSuspensao) this.NrProtocoloSuspensao = obj.NrProtocoloSuspensao
            if (obj.NrAnoprotocoloSuspensao) this.NrAnoprotocoloSuspensao = obj.NrAnoprotocoloSuspensao
            if (obj.DtSuspensao) this.DtSuspensao = new Date(obj.DtSuspensao)
            this.FlAtivo = obj.FlAtivo
        }
    }
}